module.exports = __webpack_public_path__ + "static/media/sportDark.1683db4f.svg";